import { useState, useEffect } from 'react';
import { useSocketStore } from '../stores/socketStore';

export interface AutoRoomTheme {
  id: string;
  name: string;
  description: string;
  playlistId: string;
  icon: string;
  color: string;
  isActive: boolean;
  priority: number;
  playerCount: number;
  roomCode: string | null;
}

export function useAutoRooms() {
  const { socket, isConnected } = useSocketStore();
  const [themes, setThemes] = useState<AutoRoomTheme[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  
  const fetchThemes = () => {
    if (!socket || !isConnected) return;
    setIsLoading(true);
    socket.emit('autorooms:themes');
  };
  
  const joinAutoRoom = useSocketStore(state => state.joinAutoRoom);

  useEffect(() => {
    if (!socket) return;
    
    const handleThemes = ({ themes: themesData }: { themes: AutoRoomTheme[] }) => {
      setThemes(themesData);
      setIsLoading(false);
    };
    
    socket.on('autorooms:themes', handleThemes);
    
    return () => {
      socket.off('autorooms:themes', handleThemes);
    };
  }, [socket]);
  
  // Charger au mount
  useEffect(() => {
    if (isConnected) {
      fetchThemes();
    }
  }, [isConnected]);
  
  return {
    themes,
    isLoading,
    fetchThemes,
    joinAutoRoom,
  };
}
